import axios from 'axios';

// Every Messages URL lives here and nowhere else, the same way the segments and
// policyholders clients are arranged.
const api = () => window.store.event_backend_api;
const base = () => `${api()}/messages`;

// Multipart only when there is a file to carry; a text-only message stays JSON.
const payload = (body, files = []) => {
  if (!files.length) return { body };

  const form = new FormData();
  if (body) form.append('body', body);
  files.forEach((file) => form.append('files[]', file));
  return form;
};

/**
 * The conversation list, already split into waiting and answered by the server
 * — one question about each row, and two callers computing it separately is how
 * they come to disagree.
 */
export const listConversations = (params = {}) =>
  axios.get(base(), { params }).then(({ data }) => data.data);

export const readConversation = (policyholderId) =>
  axios.get(`${base()}/${policyholderId}`).then(({ data }) => data.data);

export const sendMessage = (policyholderId, body, files = []) =>
  axios.post(`${base()}/${policyholderId}`, payload(body, files)).then(({ data }) => data.data);

export const startCall = (policyholderId, mode) =>
  axios.post(`${base()}/${policyholderId}/call`, { mode }).then(({ data }) => data.data);

export const callLeaveUrl = (policyholderId, messageId) => `${base()}/${policyholderId}/calls/${messageId}/leave`;

export const myCallLeaveUrl = (messageId) => `${api()}/my/messages/calls/${messageId}/leave`;

export const reactTo = (policyholderId, messageId, emoji) =>
  axios.post(`${base()}/${policyholderId}/messages/${messageId}/reactions`, { emoji }).then(({ data }) => data.data.reactions);

export const unreadCount = () =>
  axios.get(`${base()}/unread-count`).then(({ data }) => data.data.unread_count);

/** A one-use pass for the websockets service to join the viewer's Messages room. */
export const liveGrant = () =>
  axios.post(`${base()}/live`).then(({ data }) => data.data);

export const readMyThread = () =>
  axios.get(`${api()}/my/messages`).then(({ data }) => data.data);

const reportProgress = (onProgress) => (event) => {
  if (event?.total && onProgress) onProgress(event);
};

const uploadArgs = (body, files = [], onProgress) => {
  if (!files.length) return [payload(body, files)];

  return [payload(body, files), { onUploadProgress: reportProgress(onProgress) }];
};

export const sendMine = (body, files = [], onProgress) =>
  axios.post(`${api()}/my/messages`, ...uploadArgs(body, files, onProgress)).then(({ data }) => data.data);

export const reactToMine = (messageId, emoji) =>
  axios.post(`${api()}/my/messages/${messageId}/reactions`, { emoji }).then(({ data }) => data.data.reactions);

/** Through the scoped route, never a public URL: the file is private to the two ends. */
export const downloadAttachment = async (attachment) => {
  const { data } = await axios.get(`${base()}/attachments/${attachment.id}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.download = attachment.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
